import { Component, HostBinding } from '@angular/core';
import { WorkflowCategory, WorkflowService } from '@workflow/services/workflow.service';
import { Observable } from 'rxjs';

@Component({
	// eslint-disable-next-line @angular-eslint/component-selector
	selector: 'ol[workflow-steps]',
	templateUrl: './steps.component.html',
	styleUrls: ['./steps.component.scss'],
})
export class StepsComponent {
	@HostBinding('class.steps')
	public readonly isSteps = true;
	public readonly categories$: Observable<WorkflowCategory[]>;
	
	constructor(workflowService: WorkflowService) {
		this.categories$ = workflowService.workflowCategories$;
	}
	
}
